<template>
  <Page :title="title">
    <div class="header">
      <div class="logo">
        <img :src="require('@/assets/img/logo.png')" alt="" />
      </div>
    </div>
    <div class="content">
      <surveyProblem
        v-if="currentProblem.id"
        :problem="currentProblem"
        @change="changeOptions"
      ></surveyProblem>
      <div v-if="!currentProblem.id && errorMessage" class="empty-message">
        {{ errorMessage }}
      </div>
      <div class="van-overlay loading" v-if="loading">
        <van-loading />
      </div>
    </div>
    <div class="footer flex">
      <div
        class="secondary item1"
        v-if="currentProblem.id && currentProblem.isOrFirst !== '0'"
        @click="previous"
      >
        上一题
      </div>
      <div
        class="primary item1"
        v-if="currentProblem.id && currentProblem.isOrFirst !== '1'"
        @click="next"
      >
        下一题
      </div>
      <div
        class="primary item1"
        v-if="currentProblem.id && currentProblem.isOrFirst === '1'"
        @click="submit"
      >
        提交
      </div>
      <div
        v-if="!currentProblem.id"
        class="primary item1"
        @click="redirectClientDetail"
      >
        退出
      </div>
    </div>
  </Page>
</template>
<script lang="js">
import surveyProblem from './surveyProblem.vue';
export default {

    components:{
        surveyProblem: surveyProblem,
    },
    data(){
        return {
            title: '问卷调查',
            surveyId: null,
            custId: null,
            purchaseRecordId: null,
            survey: {},
            problems:[],
            current: 0,
            visitHistory: [],
            answers:[],
            currentProblem: {},
            loading: false,
            errorMessage: '',
        }
    },
    created(){
        let surveyId = this.$route.query.surveyId;
        let custId = this.$route.query.custId;
        let purchaseRecordId = this.$route.query.purchaseRecordId;
        this.surveyId = surveyId;
        this.custId = custId;
        this.purchaseRecordId = purchaseRecordId;
        if (surveyId && custId) {
            this.querySurveyDetail(surveyId, custId, purchaseRecordId);
        }
    },
    watch:{
        current(newVal, oldVal){
            this.currentProblem = {...(this.problems[this.current] || {})}
        }
    },
    mounted(){
    
    },
    methods: {
        // 显示问卷异常信息
        showSurveyError(){
            this.survey = {};
            this.problems = [];
            this.current = 0;
            this.visitHistory = [];
            this.currentProblem = {};
            this.errorMessage = '无此问卷信息，请联系管理员';
        },
        // 查询问卷详情
        async querySurveyDetail(surveyId, custId, purchaseRecordId){
            try {
                let response = await this.$api.querySurveyDetail({
                  salesId: this.$wxuserUtil.getUserId(),
                  surveyId: surveyId,
                  custId: custId,
                  purchaseRecordId: purchaseRecordId,
                })
                if(response.fail){
                    this.showSurveyError()
                    return
                }
                this.survey = response.data;
                // 先组装好数据再赋值，保证 answer 字段是响应式的
                let problems = (response.data.problems || []).slice().sort((a, b) => {
                    return (a.sort || 0) - (b.sort || 0)
                });
                problems.forEach(p => {
                    p.options = (p.options || []).slice().sort((a, b) => {
                        return (a.sort || 0) - (b.sort || 0)
                    })
                    p.answer = {};
                })
                this.problems = problems;
                this.current = 0;
                this.visitHistory = [];
                this.currentProblem = this.problems[0] || {};
                if (!this.currentProblem.id) {
                    this.showSurveyError()
                }
            } catch (error) {
                this.showSurveyError()
            }
        },
        // 更新当前题答案
        changeOptions(problem){
            this.problems[this.current].answer = problem.answer
            this.problems[this.current].options = problem.options
        },
        // 判断是否第一题
        isFirstProblem(problem){
            return String(problem.isOrFirst) === '0' || this.current <= 0
        },
        // 判断是否最后一题
        isLastProblem(problem){
            return String(problem.isOrFirst) === '1' || this.current >= this.problems.length - 1
        },
        // 统一处理单选和多选答案
        normalizeSelectedOptionIds(optionId){
            if (Array.isArray(optionId)) {
                return optionId
            }
            return optionId ? [optionId] : []
        },
        // 获取下一题下标（基于最新答案计算跳题）
        getNextProblemIndex(){
            let problem = this.problems[this.current] || {}
            let selectedIds = this.normalizeSelectedOptionIds(
                problem.answer && problem.answer.optionId
            )
            let selectedOption = (problem.options || []).find(option => {
                return selectedIds.indexOf(option.id) >= 0 && option.next
            })
            if (selectedOption) {
                let index = this.problems.findIndex(p => p.id === selectedOption.next)
                if (index >= 0) {
                    return index
                }
            }
            return this.current + 1
        },
        // 校验题目：仅当选中 isContent=1 的选项（如"其他，请填写"）时，必须填写内容
        validateProblemContent(problem){
            if (!problem) {
                return true
            }
            let selectedIds = this.normalizeSelectedOptionIds(
                problem.answer && problem.answer.optionId
            )
            let emptyOption = (problem.options || []).find(option => {
                return String(option.isContent) === '1'
                    && selectedIds.indexOf(option.id) >= 0
                    && !String(option.optionContent || '').trim()
            })
            if (emptyOption) {
                this.$title("请填写选项【" + (emptyOption.name || '') + "】的内容")
                return false
            }
            return true
        },
        // 校验答题路径上（含当前题）所有题目的必填内容
        validateSurveyContent(){
            let indexes = this.visitHistory.concat([this.current])
            return indexes.every(index => this.validateProblemContent(this.problems[index]))
        },
        // 返回上一题
        previous(){
            if (!this.currentProblem.id) {
                return
            }
            if(this.isFirstProblem(this.currentProblem)){
                return              
            }
            this.current = this.visitHistory.length > 0
                ? this.visitHistory.pop()
                : this.current - 1
        },
        // 进入下一题（用最新答案做必填校验，而不是切题时的旧副本）
        next(){
            if (!this.currentProblem.id) {
                return
            }
            if(!this.validateProblemContent(this.problems[this.current])){
               return
            }
            if(this.isLastProblem(this.currentProblem)){
               return
            }
            let nextIndex = this.getNextProblemIndex()
            if (nextIndex < 0 || nextIndex >= this.problems.length) {
                return
            }
            this.visitHistory.push(this.current)
            this.current = nextIndex
        },
        // 提交问卷答案
        async submit(){
            if(!this.validateSurveyContent()){
                return
            }
            let param = {
                salesId: this.$wxuserUtil.getUserId(),
                  custId: this.custId,
                  purchaseRecordId: this.purchaseRecordId,
                  json: JSON.stringify(this.problems),
            }
            try {
                this.loading = true
                let response = await this.$api.submitSurvey(param);   
                this.loading = false                 
                if(response.fail){
                    this.$title("提交问卷失败" + (response.msg ? ', ' + response.msg : ''))
                    return
                }                
                this.$title("提交问卷成功");
                this.redirectClientDetail();
            } catch (error) {
                this.loading = false;
                this.$title("提交问卷失败")
            }                        
        },
        redirectClientDetail(){
            this.$router.push({
                path: "/ClientDetails",
                query: {
                    custId: this.custId,
                    IdCode: 12,
                    showCC: this.$store.state.show==1||localStorage.getItem('show')==1
                },
            })}
    }
}
</script>    
<style scoped lang="less" rel="stylesheet/less">
.logo {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  img {
    width: 2rem;
    height: 2rem;
    margin: 30px auto;
  }
}

.content {
  margin: 0.5rem;
}
.empty-message {
  margin-top: 1rem;
  text-align: center;
  font-size: 15px;
  color: #333;
}
.loading {
  z-index: 2000;
  display: flex;
  justify-content: center;
  align-items: center;
}

.footer {
  height: 46px;
  line-height: 46px;
  text-align: center;
  font-size: 15px;
  color: #fff;
  position: fixed;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 5;
}
.secondary {
  background-color: #222;
}
.primary {
  background-color: #e10913;
}
</style>



// WEBPACK FOOTER //
// src/components/client/childCompoents/submitSurvey.vue